import { render } from "./CardProjectDemands.vue?vue&type=template&id=686ff245&scoped=true&ts=true"
import script from "./CardProjectDemands.vue?vue&type=script&lang=ts"
export * from "./CardProjectDemands.vue?vue&type=script&lang=ts"

import "./CardProjectDemands.vue?vue&type=style&index=0&id=686ff245&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686ff245"]])

export default __exports__